export const copyText = (text) => {
  if (!navigator.clipboard) {
    console.error('Clipboard API not supported');
    return;
  }
  navigator.clipboard
    .writeText(text)
    .then(() => {
      console.info('Text copied to clipboard');
    })
    .catch((err) => {
      console.error('Failed to copy text: ');
    });
};
